'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CARD_CHANNEL = exports.CARD_CHANNEL = '__reactackle-card__';
var APP_CHANNEL = exports.APP_CHANNEL = '__reactackle-app__';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-core/dist/utils/contextChannel.js
// module id = 635
// module chunks = 0